import Component from "./Header";
import CounterInline from "./components/CounterInline/HeaderCounterInline";
import LeftAddon from "./components/LeftAddon/HeaderLeftAddon";
import RightAddon from "./components/RightAddon/HeaderRightAddon";
import Subtitle from "./components/Subtitle/HeaderSubtitle";
import Title from "./components/Title/HeaderTitle";

export interface IHeaderExtensions {
    LeftAddon: typeof LeftAddon;
    Title: typeof Title;
    CounterInline: typeof CounterInline;
    Subtitle: typeof Subtitle;
    RightAddon: typeof RightAddon;
}

export const Header: typeof Component & IHeaderExtensions = Object.assign(
    Component,
    {
        LeftAddon,
        Title,
        CounterInline,
        Subtitle,
        RightAddon,
    },
);
